export default "__VITE_ASSET__CBQvJ821__"